import {IntermediatePart} from "../../intermediatePart";
import store from "../../../../../store";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Range extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'range';
    this.partName = 'Range';
    this.translateId = "visualizer.kitchen.appliance.range";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Range());
    // const rangeType = dbFeature.metaData && dbFeature.metaData["RangeType"];
    // if (!rangeType) {
    //   dbFeature.metaData["RangeType"] = ["ALL"];
    // }
  }

  handleClick(ignoreLocked = false, clickFrom = "") {
    const {isEncore} = store.getState().fabricatorState;
    if (isEncore) {
      const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
      if (ignoreLocked || !featureIsLocked) {
        const applianceParent = this.getParent().getParent();
        if (applianceParent.layout.type === 6) {
          if (applianceParent.hood && !applianceParent.hood.disabled) {
            applianceParent.hood.disabled = true;
          }
          if (applianceParent.oven && !applianceParent.oven.disabled) {
            applianceParent.oven.disabled = true;
          }
          if (applianceParent.microwave && applianceParent.microwave.disabled) {
            applianceParent.microwave.disabled = false;
          }
        }
      }
    }
    return super.handleClick(ignoreLocked, clickFrom);
  }

  disabledClick() {
    const applianceParent = this.getParent();
    if ((applianceParent.layout.type === 6) && !this.disabled && applianceParent.stovetop
      && !applianceParent.stovetop.disabled) {
      applianceParent.stovetop.disabled = true;
    }
  }

}
